import React from 'react';
import { useTestSearchContext } from '../contexts/test-search.context';
import OptionItem from './option-item.component';
import { TEST_COLLECTIONS } from '../constants';
import { CustomDateTimePicker } from '../../../../components/datetimepicker';
import { CUSTOM_EVENTS, DATE_TIME_FORMAT } from '../../../../utils/constants';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import GoogleAutocomplete from '../../../../components/googleautocomplete/googleautocomplete.component';
import useFetchTestCenters from '../../../../hooks/useFetchTestCenters';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import GoogleMapComponent from '../../../../components/googlemap/GoogleMap.component';
import CityValidation from './cityValidation.component';

const LocationService = () => {
    const {
        selectedLocation, setSelectedLocation,
        setCoordinate, setCity
    } = useTestSearchContext();

    const handleLocation = (locData) => {
        console.log({locData});
        let loc = '';
        let coord = null;
        let city = '';
        if (locData) {
            const {formatted_address: formattedAddress, geometry: { location: { lat, lng } }, address_components} = locData;
            loc = formattedAddress;
            coord = { lat: lat(), lng: lng() };
            const cityData = address_components.find(({types}) => types.includes('locality'));
            if (cityData) {
                city = cityData.long_name;
            }
        }
        setSelectedLocation(loc);
        setCoordinate(coord);
        setCity(city);
    };

    return (
        <GoogleAutocomplete
            setAddress={handleLocation}
            address={selectedLocation}
            textFieldProps={{ label: 'Location', placeholder: 'Location' }}
        />
    );
};

const TestCollection = () => {
    const {
        collectionType, setCollectionType,
        selectedLocation, setSelectedLocation,
        testDate, setTestDate,
        setCoordinate, setCity
    } = useTestSearchContext();
    const {testCenters} = useFetchTestCenters();

    const handleSelection = (value) => {
        setCollectionType(value);
        setSelectedLocation('');
        setCoordinate(null);
        setCity('');
    };

    const handleClickedCenter = (data) => () => {
        const { location, coordinate: { coordinates: [ lng, lat ] } } = data;
        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.UPDATE_MAP_CENTER, { detail: { lng, lat, title: location } }));
        setCoordinate({ lat, lng });
    };

    const handleCenterData = (e) => {
        setSelectedLocation(e.target.value);
    };

    const testCentersListSelect = () => {
        const testItems = testCenters.map((testCenter) => <MenuItem key={testCenter.id} value={testCenter.location} onClick={handleClickedCenter(testCenter)}>{testCenter.name}</MenuItem>);
        // const testItems = testCenters.map((testCenter) => <MenuItem key={testCenter.id} value={testCenter.location}>{testCenter.name}</MenuItem>);
        return (
            <Stack spacing={2}>
                <FormControl fullWidth>
                    <InputLabel id="center-services-dd">Test Centers</InputLabel>
                    <Select
                        labelId="center-services-dd"
                        // name='services'
                        value={selectedLocation}
                        label="Test Centers"
                        onChange={handleCenterData}
                    >
                        {testItems}
                    </Select>
                </FormControl>
                <GoogleMapComponent />
            </Stack>
        );
    };

    const locationsUI = () => {
        if (collectionType === 1) {
            return (
                <>{testCentersListSelect()}</>
            );
        }

        return (
            <>
                <LocationService />
                <CityValidation />
            </>
        );
    };

    const date = testDate ? new Date(testDate) : new Date();
    const testDateUI = (
        // <CustomDateTimePicker
        //     name="testDate"
        //     value={dayjs(date)}
        //     handleChange={(value) => setTestDate(format(new Date(value), DATE_FORMAT))}
        //     dateOnly={true}
        //     label="Prefer Date"
        // />
        <CustomDateTimePicker
            name="testDate"
            value={dayjs(date)}
            // handleChange={(value) => setNewApptDateTime(format(new Date(value), DATE_TIME_FORMAT))}
            handleChange={(value) => setTestDate(format(new Date(value), DATE_TIME_FORMAT))}
        />
    );

    const options = TEST_COLLECTIONS.map((opt, i) => <OptionItem key={i} {...opt} onSelect={handleSelection} isChecked={collectionType === opt.value} />);
    return (
        <div className='test-selection-container'>
            <div className="space-around">{options}</div>
            <div>{locationsUI()}</div>
            <div>{testDateUI}</div>
        </div>
    );
};

export default TestCollection;